module.exports = __webpack_public_path__ + "img/icon.ebc9adce.svg";